import React from 'react';
const frictions = ['Buscas durante horas y encuentras recursos genéricos, fríos o sin propósito.', 'Los folletos informativos no siempre generan conversación.', 'Una charla teórica puede terminar sin que las participantes conecten con el mensaje.'];
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-119" data-mp="2geasi8x7myde">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-120" data-mp="2ggwzo7g6vbv3">
        <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-rose-600" data-id="element-121" data-mp="21od53v73ucp9">
          El Problema Real
        </p>
        <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-122" data-mp="1sp81wbkllv6r">
          Tienes la intención.{' '}
          <span className="bg-rose-200 px-1.5 pb-0.5 text-plum-900" data-id="element-123" data-mp="1wrct73nkqfq8">No tienes el material.</span>
        </h2>

        <ul className="mt-11 space-y-4 text-left" data-id="element-124" data-mp="1irtxjaby8wut">
          {frictions.map(item => <li key={item} className="flex items-start gap-4 border-l-4 border-gold-300 bg-canvas px-5 py-4 text-lg text-gray-600 md:px-6 md:text-xl" data-id="element-125" data-mp="1npddqfs7jjpe">
              {item}
            </li>)}
        </ul>

        <p className="mt-11 font-display text-2xl font-extrabold leading-snug tracking-tight text-ink md:text-3xl" data-id="element-126" data-mp="12b50tok2j8wx">
          Octubre se acerca y mientras tú buscas soluciones, otros facilitadores ya están
          transformando sus jornadas.
        </p>
        <p className="mt-4 text-lg text-gray-500" data-id="element-127" data-mp="9jv4hjd7zlwe">¿Y tú qué haces? ¿Otro año más viéndolos pasar?</p>
      </div>
    </section>;
}